import { MODELS_SET_LIST, MERCH_SET_LIST } from "./../types";

import { createReducer } from "./functions";
import { MODEL_SET_LIST_LOADING } from "../actions/modelActions";

const initialState = {
  modelsList: {},
  modelsListLoading: false,
  page: 0,
  pages: 0,
  pageSize: 10,
  hasNext: true,
  currentFilters: {},
  sort: { active: -1, "periodicity.endDate": -1, "periodicity.startDate": -1, _id: -1 }
};

const setModelsList = {
  [MODELS_SET_LIST]: (state, action) => {
    const page = action.payload.hasOwnProperty("page") ? action.payload.page : state.page;
    const pages = action.payload.hasOwnProperty("pages") ? action.payload.pages : state.pages;
    let hasNext = true;

    if (page === 0 || page === pages) {
      hasNext = false;
    }

    return {
      ...state,
      modelsList: action.payload.docs,
      page,
      pages,
      hasNext
    };
  },
  [MODEL_SET_LIST_LOADING]: (state, { loading = false }) => {
    return {
      ...state,
      modelsListLoading: loading
    };
  },
  [MERCH_SET_LIST]: (state, action) => {
    const page = action.payload.hasOwnProperty("page") ? action.payload.page : state.page;
    const pages = action.payload.hasOwnProperty("pages") ? action.payload.pages : state.pages;
    const total = action.payload.hasOwnProperty("total") ? action.payload.total : state.total;
    let hasNext = true;

    if (page === 0 || page === pages) {
      hasNext = false;
    }

    return {
      ...state,
      merchList: action.payload.docs,
      page,
      pages,
      hasNext,
      total
    };
  }
};

const modelsReducer = createReducer(initialState, {
  ...setModelsList
});

export default modelsReducer;



// WEBPACK FOOTER //
// src/redux/reducers/modelsReducer.js